import { QueryClient } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { localStoragePersister } from "../persistor";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 1 * 60 * 60 * 1000, // 1 hour
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
      refetchOnMount: true, // Refetch on mount (background)
      refetchOnReconnect: true, // Refetch on reconnect
    },
    mutations: {
      retry: 1,
    },
  },
});
persistQueryClient({
  queryClient,
  persister: localStoragePersister,
  maxAge: 24 * 60 * 60 * 1000, // 24 hours
  dehydrateOptions: {
    shouldDehydrateQuery: (query) => {
      // Exclude the "auth -> current-user" query from persistence
      return (
        (Array.isArray(query.queryKey) && query.queryKey[0] !== "auth") ||
        query.queryKey[1] !== "current-user"
      );
    },
  },
});
